import React, { Fragment } from 'react';

import { localizable } from '../../../components/Localization';
import BaseStep from '../components/BaseStep';

@localizable
class NotifySellerSummary extends BaseStep {
  render() {
    var { store, t } = this.props;
    return (
      <Fragment>
        <h2>{t('Summary')}</h2>
        <div>{t('description')}</div>
        <ol>
          {store.offers.map((i) => (
            <li key={i.buyerId}>{this.renderBuyerName(i.item)}</li>
          ))}
        </ol>
        <h3>{t('Message to seller')}</h3>

        <p>{store.message || <i>{t('Not entered')}</i>}</p>
      </Fragment>
    );
  }
}

export default NotifySellerSummary;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/NotifySeller/Summary.jsx